var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex mx-3 my-0",on:{"click":_vm.newPage}},[(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('p',{staticClass:"px-1"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }